import { render, staticRenderFns } from "./loginPage.vue?vue&type=template&id=f0effa84"
import script from "./loginPage.vue?vue&type=script&lang=js"
export * from "./loginPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports